import React, { useState } from "react";
import { CheckCircle, XCircle, Clock, User } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { Badge } from "../../../components/ui/Badge";
import { Button } from "../../../components/ui/button";

export default function PartenaireCard({ partenaire, onClick }) {
  const [isHovered, setIsHovered] = useState(false);

  const getStatusIcon = (statut) => {
    switch (statut) {
      case "Actif":
        return { icon: <CheckCircle className="h-5 w-5 text-[var(--hp-success-700)]" />, bgColor: "bg-[var(--hp-success-100)]" };
      case "Inactif":
        return { icon: <XCircle className="h-5 w-5 text-[var(--hp-danger-700)]" />, bgColor: "bg-[var(--hp-danger-100)]" };
      case "Onboarding":
        return { icon: <Clock className="h-5 w-5 text-[var(--hp-warning-700)]" />, bgColor: "bg-[var(--hp-warning-100)]" };
      default:
        return { icon: null, bgColor: "" };
    }
  };

  const { icon, bgColor } = getStatusIcon(partenaire.statutConformite);

  return (
    <motion.div 
      layout
      whileHover={{ y: -4, scale: 1.02 }}
      transition={{ type: "spring", stiffness: 300, damping: 20 }}
      className="relative z-10 workspace-card p-5 cursor-pointer overflow-hidden flex flex-col h-full"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => onClick(partenaire)}
    >
      {/* En-tête : Icône de statut */}
      {icon && (
        <div className={`absolute top-3 right-3 p-1.5 rounded-full ${bgColor} shadow-hp-sm`}>
          {icon}
        </div>
      )}

      {/* Logo ou icône par défaut */}
      <div className="flex justify-center mt-2 mb-4">
        {partenaire.logo ? (
          <img 
            src={partenaire.logo} 
            alt="Logo" 
            className="h-16 w-16 object-contain rounded-md"
          />
        ) : (
          <div className="h-16 w-16 bg-surface-muted rounded-full flex items-center justify-center border border-[var(--hp-color-border-muted)]">
            <User className="h-8 w-8 text-subtle" />
          </div>
        )}
      </div>

      {/* Informations */}
      <div className="flex flex-col flex-grow text-center">
        <h3 className="text-lg font-bold text-primary line-clamp-1" title={partenaire.nom_societe}>
          {partenaire.nom_societe}
        </h3>
        
        <div className="mt-1 flex justify-center">
          <Badge variant="secondary">
            {partenaire.classe_actifs || "Non classifié"}
          </Badge>
        </div>

        <div className="mt-4 mt-auto">
          <p className="text-sm font-medium text-primary">
            {partenaire.nom_referent || "Référent inconnu"}
          </p>
          <p className="text-xs text-subtle mt-0.5 truncate">
            {partenaire.email}
          </p>
        </div>
      </div>

      {/* Overlay au survol */}
      <AnimatePresence>
        {isHovered && (
          <motion.div 
            initial={{ y: "100%", opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: "100%", opacity: 0 }}
            transition={{ type: "tween", ease: "circOut", duration: 0.2 }}
            className="absolute inset-x-0 bottom-0 bg-workspace/90 backdrop-blur-sm border-t border-[var(--hp-color-border-muted)] p-4 flex justify-center items-center"
          >
            <Button variant="secondary" size="sm" className="w-full">
              Voir le dossier
            </Button>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}
